import React from 'react';
import { Table, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { SingleOpenItemDetailsType } from '../../../redux/openItems/openItemsTypes';
import { TableHeader } from '../../commons';
import { formatDate } from '../../../utils/commonFunctions';
import { UploadIconOpenItem } from '../../Icon';
import { PaperClipIcon } from '../../Icon';
import moment from 'moment';

type AppProps = {
  headers?: any;
  adminOpenItemSingle?: SingleOpenItemDetailsType;
  toggleFileUploadModal: () => void;
  toggleCommentModal: () => void;
  handleSetOpenItemId: (id: number | undefined) => void;
  renderCommentsModal: (data: any) => void;
  fileData?: [] | any[];
  handleEditFileList: (index: number, itemId: number) => void;
}

const ClientDocumentSummary = ({
  headers,
  adminOpenItemSingle,
  toggleFileUploadModal,
  handleSetOpenItemId,
  toggleCommentModal,
  renderCommentsModal,
  fileData
}: AppProps) => {

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const getStatus = (status: any) => {
    switch (true) {
      case (status == 1):
        return 'Pending';
      case (status === 2):
        return 'Rejected';
      case (status === 3):
        return 'Approved';
      default: return;
    }
  }

  const returnFileFormat = (format: string) => {
    switch (format) {
      case 'image':
        return 'Image';
      case 'word':
        return 'Word';
      case 'pdf':
        return 'PDF';
      case 'excel':
        return 'Excel';
      case 'hard_copy':
        return 'Hard Copy';
      default:
        return 'Image';
    }
  }

  const handleUploadIconClick = (id: number | undefined) => {
    toggleFileUploadModal();
    handleSetOpenItemId(id);
  }


  const returnDocumentList = (itemId: number) => {
    let finalDocumentCount;
    fileData?.map((data: any) => {
      if (data.item_id === itemId) {
        finalDocumentCount = data.file_data?.length;
      }
    });

    return finalDocumentCount ?? 0;
  };

  const handleCommentsModalData = (data: any) => {
    toggleCommentModal();
    renderCommentsModal(data);
  };

  const renderFilesList = (itemId: number) => {
    return fileData?.map((data: any) => {
      if (data.item_id === itemId) {
        return <>
          {data?.file_data.map((file: any, index: number) => (
            <p className="mt-3" key={index}>
               {/* eslint-disable-next-line  */}
              <a href={file?.file_url ? `${ blobBaseUrl }${ file?.file_url }?${ blobToken }` : ''} target="_blank" className="uploaded_file_name">
                {file?.file_name}
              </a>
              {/* // DO NOT DELETE  KEPT FOR FUTURE USE*/}
              {/* <a
                className="pointer"
                onClick={() => handleEditFileList?.(index, data?.item_id)}
              >
                <TrashIcon />
              </a> */}
            </p>
          ))}
        </>
      }
    });
  }

  const renderUploadedFiles = (itemId: number) => {
    return (
      <UncontrolledPopover trigger="legacy" placement="bottom" target={`PopoverLegacy${ itemId }`}>
        <PopoverHeader>Total uploaded file list</PopoverHeader>
        <PopoverBody>
          {renderFilesList(itemId)}
        </PopoverBody>
      </UncontrolledPopover>
    )
  }

  const renderDocuments = () => {
    return adminOpenItemSingle?.documents && adminOpenItemSingle?.documents.length && adminOpenItemSingle?.documents.map((item: any) => {
      const finalComment = item?.last_comment?.length > 15 ? `${ item?.last_comment.slice(0, 15) }...` : item?.last_comment;

      return <tr>
        <td className=''>{item.item_name}</td>
        <td>
          <span className={`file-status-${ item?.format }`}>{returnFileFormat(item?.format)}</span>
        </td>
        <td className=''>{formatDate(item?.due_date)}</td>
        <td className=''>
          <span className={`status-${ getStatus(item.approval_status_code) }`}>
            {getStatus(item.approval_status_code)}
          </span>
        </td>
        <td className=''>{finalComment ?
          <>
            <span>{finalComment}</span><br />
            <span className="due-date-text">{moment.utc(item?.last_comment_date).local().format('DD-MM-YY, h:mm a')}</span>
          </> :
          '--/--'
        }</td>
        {
          returnDocumentList(item?.item_id) ? <td className="position-relative pointer">
            <span id={`PopoverLegacy${ item?.item_id }`}>
              <PaperClipIcon />
              <span className="badge count-badge">
                {returnDocumentList(item?.item_id)}
              </span>
            </span>
            {renderUploadedFiles(item?.item_id)}
          </td> : <td> --/-- </td>
        }
        <td
          className='pointer'
        >
          <span
            onClick={() => handleUploadIconClick(item?.item_id)}
          >
            <UploadIconOpenItem />
          </span>
        </td>
        <td>
          <i
            className="fas fa-comments comment-icon"
            onClick={() => handleCommentsModalData(item)}
          ></i>
        </td>
      </tr>
    })
  }

  return (
    <div style={{ overflow: 'auto' }}>
      <Table className='table-striped'>
        <thead>
          <TableHeader tableHeader={headers} />
        </thead>
        <tbody>
          {renderDocuments()}
        </tbody>
      </Table>
    </div>
  )
};

export default ClientDocumentSummary;